import { createAsyncThunk } from "@reduxjs/toolkit";
import { addSuccessNotification } from "../common/notificationSlice";
import { getErrorPayload } from "@application/common/helpers/api-helper";
import PurchaseInvoiceLineApi from "@infrastructure/purchase-invoice-line-api";
export const getArticalByIdAsync = createAsyncThunk('artical/GetById', async (articalId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await PurchaseInvoiceLineApi.getArticleById(articalId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllArticalsAsync = createAsyncThunk('workorder/GetAllArticals', async (_, { rejectWithValue }) => {
    try {
        const response = await PurchaseInvoiceLineApi.getAllArticals();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getWorkOrdersListWithClientAsync = createAsyncThunk('PurchaseInvoice/getWorkOrdersListWithClientAsync', async (workOrderNumber, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await PurchaseInvoiceLineApi.getWorkOrdersListWithClientAsync(workOrderNumber);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createPurchaseInvoiceLineAsync = createAsyncThunk('PurchaseInvoice/Create', async (purchaseInvoiceLine, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await PurchaseInvoiceLineApi.CreatePurchaseInvoiceLine(purchaseInvoiceLine);
        dispatch(addSuccessNotification("Record succesvol aangemaakt"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllPurchaseInvoiceLineByIdAsync = createAsyncThunk('PurchaseInvoice/GetAllPurchaseInvoiceLinesById', async (purchaseInvoiceLineId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await PurchaseInvoiceLineApi.getAllPurchaseInvoiceLinesById(purchaseInvoiceLineId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPurchaseInvoiceLineByIdAsync = createAsyncThunk('PurchaseInvoice/GetPurchaseInvoiceLineByID', async (Id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await PurchaseInvoiceLineApi.getPurchaseInvoiceLineById(Id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updatePurchaseInvoiceLineAsync = createAsyncThunk('PurchaseInvoiceLine/Update', async (purchaseInvoiceLine, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await PurchaseInvoiceLineApi.UpdatePurchaseInvoiceLine(purchaseInvoiceLine.id, purchaseInvoiceLine);
        dispatch(addSuccessNotification("Record succesvol bijgewerkt"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deletePurchaseInvoiceLineAsync = createAsyncThunk(`PurchaseInvoiceLine/Delete`, async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await PurchaseInvoiceLineApi.deletePurchaseInvoiceLine(id);
        dispatch(addSuccessNotification('Record succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
